import FixedHeader from "../components/FixedHeader";
import Notification from "../components/Notification";
import { motion } from "framer-motion";
import Social from "../components/Social";
import FixedNotification from "../components/FixedNotification";
import logoparque from "../img/logoparque.png";
import Block3Columns from "../components/Block3Columns";
import Block4Columns from "../components/Block4ColumnsText";
import Block2ColumnsText from "../components/Block2ColumnsText";
import ModalFixed from "../components/ModalFixed";
import DataFetcherNews from "../hooks/fetchNews";

import icon1 from "../img/icons/innovacion.png";
import icon2 from "../img/icons/tecnologias.png";
import icon3 from "../img/icons/biotecnologia.png";
import icon4 from "../img/icons/industria.png";
import icon5 from "../img/icons/aprendizaje.png";

import laboratorios from "../img/icons/investigacion.gif";
import publicaciones from "../img/icons/publicacion.gif";
import grupos from "../img/icons/grupos.gif";

import BlockLeftImage from "../components/BlockLeftImage";

import logo1 from "../img/icons/Recurso 3.png";
import logo2 from "../img/icons/Recurso 2.png";
import logo3 from "../img/icons/Recurso 13.png";
import logo4 from "../img/icons/Recurso 14.png";
import logo5 from "../img/icons/Recurso 15.png";
import logo6 from "../img/icons/Recurso 6.png";
import logo7 from "../img/icons/Recurso 5.png";
import quali from "../img/icons/QUALIPHARM.png";
import tikee from "../img/icons/Tikee.png";
import quo from "../img/icons/QUOHUB.png";

import logon1 from "../img/icons/Recurso 1.png";
import logon2 from "../img/icons/Recurso 16.png";
import ile from "../img/icons/ile.png";
import favorita from "../img/icons/la_favorita.png";
import comercio from "../img/icons/comercio.png";
import funeraria from "../img/icons/funeraria.png";
import malca from "../img/icons/malca.png";
import cafrilosa from "../img/icons/cafrilosa.jpg";
import ecolac from "../img/icons/ecolac.png";
import equimec from "../img/icons/Equimec.jpeg";
import novandina from "../img/icons/novandina.png";
import logajas from "../img/icons/Lojagas.jpg";
import gedex from "../img/icons/GEDES.jpg";
import alpina from "../img/icons/Alpina.jpg";
import citec from "../img/icons/CITEC.png";

import red1 from "../img/icons/Recurso 10.png";
import red2 from "../img/icons/Recurso 7.png";
import agro from "../img/icons/agro.jpg";
import cedia from "../img/icons/cedia.png";

import parque1 from "../img/icons/Recurso 4.png";
import parque2 from "../img/icons/Recurso 8.png";

import retos from "../img/icons/retos.png";
import proyectos from "../img/icons/proyectos.png";

import video from "../videos/loop_pcyt.mp4";
import incubacion from "../img/logoscalidad/incubacion.png";

import Carousel from "../components/Carousel";

import adriana from "../img/icons/equipoparque/adriana.png";
import noelia from "../img/icons/equipoparque/noelia.png";
import diana_sanchez from "../img/icons/equipoparque/diana_sanchez.png";
import galo_ojeda from "../img/icons/equipoparque/galo_ojeda.png";
import jaime_roman from "../img/icons/equipoparque/jaime_roman.png";
import juan_pablo_ from "../img/icons/equipoparque/juan_pablo.png";
import mauricio_eguiguren from "../img/icons/equipoparque/mauricio_eguiguren.png";
import Flipcard from "../components/Flipcard";

import icon_1 from "../img/icons/equipoparque/global.gif";
import icon_2 from "../img/icons/equipoparque/gif-celular.gif";
import icon_3 from "../img/icons/equipoparque/consejero.gif";
import babson from "../img/icons/equipoparque/babson-collaborative.png";
import fined from "../img/icons/equipoparque/fine-tuned.jpg";
import isben from "../img/icons/equipoparque/isben.jpg";
import cacpe from "../img/icons/equipoparque/cacpe.png";
import facebook from "../img/logoscolor/fb.png";
import instragram from "../img/logoscolor/in.png";
import x from "../img/logoscolor/tw.png";
import LogoGrid from "../components/LogoGrid";
function ParqueCientifico() {
  let mystyle = {
    backgroundImage: `url(${logoparque})`,
  };

  const logos = [
    logo1,
    logo3,
    logo5,
    logo6,
    logo7,
    quali,
    tikee,
    quo,
    equimec,
    novandina,
    fined,
    isben,
  ];

  const logos2 = [
    logon1,
    logon2,
    ile,
    favorita,
    comercio,
    funeraria,
    malca,
    cafrilosa,
    ecolac,
    logajas,
    gedex,
    alpina,
    cacpe,
  ];
  return (
    <>
      <FixedHeader
        video={video}
        src="https://utpl.edu.ec/recursos/img/cabecera.jpg"
        span0={
          <>
            UTPL <b>Parque</b>
          </>
        }
        span3="Científico y"
        span4="Tecnológico"
      ></FixedHeader>

      <div style={mystyle} className="intro-parquecientifico padding">
        <Notification
          content={
            <>
              <h2>
                Somos un espacio de <b>innovación</b> y <b>emprendimiento</b>{" "}
                para impulsar la
                <b> investigación</b>, el <b>desarrollo tecnológico</b> y la{" "}
                <b>transferencia de conocimiento</b>
              </h2>
            </>
          }
        ></Notification>
      </div>
      <div className="padding">
        <center>
          <h2>
            Nuestros <b>objetivos</b>{" "}
          </h2>
          <Block3Columns
            col1={
              <>
                <div className="layout8 icon100">
                  <img src={icon_1}></img>
                </div>
                <h4>
                  Fortalecer el ecosistema de innovación y emprendimiento
                </h4>{" "}
              </>
            }
            col2={
              <>
                {" "}
                <div className="layout8 icon100">
                  <img src={icon_2}></img>
                </div>
                <h4>Potenciar la transferencia de conocimiento</h4>{" "}
              </>
            }
            col3={
              <>
                {" "}
                <div className="layout8 icon100">
                  <img src={icon_3}></img>
                </div>
                <h4>
                  Fomentar en los docentes y estudiantes de la UTPL un
                  aprendizaje experiencial centrado en la innovación y el
                  emprendimiento
                </h4>
              </>
            }
          ></Block3Columns>{" "}
        </center>
      </div>
      <div className="padding graybg">
        <div className="layout8">
          <center>
            <h2 className="width700">
              Fomentamos la{" "}
              <b>
                colaboración entre las empresas, gobierno, academia y sociedad
                civil
              </b>{" "}
              para contribuir a la creación de un{" "}
              <b>ecosistema de innovación sólido y dinámico</b>
            </h2>
          </center>
          <p>
            Enfocamos nuestras prioridades en los <b>siguientes sectores:</b>
          </p>
        </div>

        <div className="icon70 padding">
          {" "}
          <Block4Columns
            col1={
              <center>
                <img src={icon1} alt="utpl"></img>
                <p>
                  Agroindustria <b> y alimentos</b>
                </p>
              </center>
            }
            col2={
              <center>
                <img src={icon3}></img>
                <p>
                  <b> Bioeconomía y </b>valorización de biomasa
                </p>
              </center>
            }
            col3={
              <center>
                <img src={icon5}></img>
                <p>
                  Sostenibilidad y <b>economía circular </b>
                </p>
              </center>
            }
            col4={
              <center>
                <img src={icon2}></img>
                <p>Tecnología</p>
              </center>
            }
          ></Block4Columns>
        </div>
      </div>
      <BlockLeftImage
        src={incubacion}
        content={
          <>
            <h2>
              Incubación y <b>aceleración de startups</b>{" "}
            </h2>
            <p>
              Ofrecemos a empresas y emprendimientos el espacio y las{" "}
              <b>
                {" "}
                herramientas de investigación y desarrollo de nuevos
                productos,{" "}
              </b>{" "}
              para que así puedan llevar su idea de negocio a la realidad.
            </p>
            <center>
              {" "}
              <Block3Columns
                col1={
                  <>
                    <h3>
                      <b>483</b>
                    </h3>
                    <p>emprendimientos incubados </p>
                  </>
                }
                col2={
                  <>
                    <h3>
                      <b>195</b>
                    </h3>
                    <p>emprendimientos graduados</p>
                  </>
                }
                col3={
                  <>
                    <h3>
                      <b>729</b>
                    </h3>
                    <p>postulaciones en programas a nivel nacional</p>
                  </>
                }
              ></Block3Columns>
              <a target="_blank" href="https://prendho.com/">
                Revisa aquí nuestra convocatoria
              </a>
            </center>
          </>
        }
      ></BlockLeftImage>

      <div className="relative padding">
        <div className="relative py-16 px-4 md:px-8 lg:px-16 bg-white">
          <div className="max-w-6xl mx-auto text-center">
            {/* Título */}
            <h2 className="text-3xl md:text-4xl font-bold text-[#004270] ">
              Vinculación{" "}
              <span className="text-amber-400 font-montserrat">empresa – universidad</span>
            </h2>

            {/* Descripción */}
            <p className="mt-4 text-lg max-w-3xl mx-auto">
              Te ayudamos a potenciar tu empresa con{" "}
              <span className="font-semibold ">
                espacios de coworking, laboratorios, acceso a redes de contactos
                nacionales e internacionales
              </span>{" "}
              y la conformación de nodos.
            </p>

            {/* Métrica */}
            <p className="mt-6 text-xl font-medium ">
              <span className="font-bold">+23 empresas</span> ya
              forman parte de nuestro ecosistema de investigación y
              emprendimiento.
            </p>

            {/* Subtítulo */}
            <h3 className="mt-10 text-xl font-semibold text-gray-700">
              Empresas <span className="text-amber-400 text-4xl font-dancing">residentes</span>
            </h3>
          </div>

          {/* Grid 1 */}
          <div className="mt-10">
            <LogoGrid logos={logos} />
          </div>

          {/* Grid 2 */}
          <div className="pt-16 text-center">
            <h3 className=" text-xl  font-semibold text-gray-700">
              Empresas <span className="text-amber-400 text-4xl font-dancing">aliadas</span>
            </h3>

            <div className="mt-8">
              <LogoGrid logos={logos2} />
            </div>
          </div>
        </div>

        <ModalFixed
          title="Esfuerzos conjuntos transforman la Industria de Alimentos en Ecuador 🥙"
          color="#2a4898"
          content={
            <>
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/otV8QCodk4M?si=sSkxka05N13LacG1"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </>
          }
        ></ModalFixed>
      </div>

      <div className="padding lightbluebg">
        <div className="layout8">
          <center>
            <h2>
              {" "}
              ¿Qué beneficios obtiene una<b> empresa residente al PCyT UTPL?</b>
            </h2>
          </center>
          <ul>
            <li>
              Espacio en el coworking empresarial del PCyT, laboratorios y otros
              espacios de uso común.
            </li>
            <li>
              Oportunidad de innovar mediante: innovación, retos y proyectos de
              innovación. Docentes – investigadores y estudiantes prototipan
              soluciones a los problemas de la empresa.
            </li>
            <li>
              Servicio de prototipado y uso de laboratorios para análisis en
              condiciones preferenciales.
            </li>
            <li>
              Información sobre fondos concursables a nivel nacional e
              internacional y formulación de propuestas conjuntas con UTPL.
            </li>
            <li>
              Acceso a las redes de contactos nacionales e internacionales del
              PCyT UTPL.
            </li>
            <li> Conformación de académicas o nodos de formación.</li>
          </ul>
        </div>
      </div>

      <div className="bluebg padding">
        <center>
          <div className="layout6">
            <h2>
              Retos de innovación <b>empresarial</b>
            </h2>
            <p>
              Juntos enfrentemos desafíos empresariales y desarrollemos ideas
              transformadoras que impulsen el crecimiento productivo del país.
            </p>
          </div>
        </center>

        <Block2ColumnsText
          col1={
            <>
              <div className="icon70 margin">
                {" "}
                <img src={retos} alt="utpl" />{" "}
              </div>

              <h4>
                <b>Retos UTPL</b>
              </h4>
              <ul>
                <li>
                  <p>Desarrollo de una solución posible</p>
                </li>
                <li>
                  <p>
                    Ejecución de la propuesta a través de un diseño digital o
                    esquema
                  </p>
                </li>
                <li>
                  <p>Prototipo funcional</p>
                </li>
                <li>
                  <p>
                    Validación de la solución por el emprendimiento o empresa
                  </p>
                </li>
                <li>
                  <p>
                    <b>Duración:</b> 90 días
                  </p>
                </li>
                <li>
                  <p>
                    <b>Resultado:</b> Un Prototipo
                  </p>
                </li>
              </ul>
              <a
                className="button margin"
                target="_blank"
                href="https://forms.office.com/pages/responsepage.aspx?id=qknrbm1D5kO-zbvfeeUHfcfbELRdUm5OsIWBRoehynJUMUpEQUFSVFlYSklQWkQ3WlkzWjVWMTRHMy4u&route=shorturl"
              >
                Inscríbete ahora
              </a>
            </>
          }
          col2={
            <>
              <div className="icon70 margin">
                {" "}
                <img src={proyectos} />{" "}
              </div>
              <h4>
                <b>Proyectos de Coinversión</b>
              </h4>
              <ul>
                <li>
                  <p>Formulación de un proyecto de innovación</p>
                </li>
                <li>
                  <p>Desarrollo del proyecto</p>
                </li>
                <li>
                  <p>
                    Cierre y validación de la solución por el emprendimiento o
                    empresa
                  </p>
                </li>
                <li>
                  <p>
                    <b>Duración:</b> hasta 12 meses
                  </p>
                </li>
                <li>
                  <p>
                    <b>Resultado:</b> Solución transferida al solicitante
                  </p>
                </li>
              </ul>

              <a
                className="button margin"
                target="_blank"
                href="https://forms.office.com/pages/responsepage.aspx?id=qknrbm1D5kO-zbvfeeUHfcfbELRdUm5OsIWBRoehynJUMEtHMUlGWVU0VktaQlpOS0pTRzlGNlA5WS4u&route=shorturl"
              >
                Inscríbete ahora
              </a>
            </>
          }
        ></Block2ColumnsText>
      </div>
      <div className="padding">
        <div className="layout8">
          <center>
            {" "}
            <h2>
              ¿Qué nos <b>diferencia?</b>
            </h2>
          </center>
        </div>
        <div className="icon100 padding2">
          <center>
            <Block3Columns
              col1={
                <>
                  <img src={laboratorios} alt="utpl"></img>
                  <h3>
                    <b>83 laboratorios</b>
                  </h3>
                  <p>
                    para generar y transferir conocimiento desde el sur del
                    Ecuador
                  </p>
                  <a
                    className="button"
                    target="_blank"
                    href=" https://investigacion.utpl.edu.ec/laboratorios"
                  >
                    Conócelos
                  </a>
                </>
              }
              col2={
                <>
                  {" "}
                  <img src={grupos} alt="utpl"></img>
                  <h3>
                    <b>73 grupos de investigación </b>
                  </h3>
                  <p>para trabajar en red</p>
                  <a
                    className="button"
                    target="_blank"
                    href="https://investigacion.utpl.edu.ec/grupos"
                  >
                    Conócelos
                  </a>
                </>
              }
              col3={
                <>
                  <img src={publicaciones}></img>
                  <h3>
                    <b>+ 3 mil publicaciones </b>
                  </h3>
                  <p>científicas indexadas en Scopus</p>
                </>
              }
            ></Block3Columns>
          </center>
        </div>
      </div>
      <div className="bluebg padding">
        <div className="layout8">
          <center>
            <h2 className="width500">
              Gestión y <b>transferencia de conocimiento</b>
            </h2>
            <p className="width500">
              Apoyamos el{" "}
              <b>
                registro de tus descubrimientos, la validación de productos o
                servicios con el sector empresarial
              </b>{" "}
              y te asesoramos en el registro de tu propiedad intelectual de
              acuerdo con tu giro de negocio.
            </p>
          </center>
        </div>
        <center>
          <Block4Columns
            col1={
              <>
                <h3>
                  <b>310</b>{" "}
                </h3>
                <p>
                  registros de propiedad intelectual reconocidos nacional e
                  internacionalmente{" "}
                </p>
                <a href="https://data.utpl.edu.ec/search?search=&broader=propiedad_intelectual&ordering=-year&page=1">
                  Más información
                </a>
              </>
            }
            col2={
              <>
                <h3>
                  <b>+74</b>{" "}
                </h3>
                <p>patentes</p>
              </>
            }
            col3={
              <>
                <h3>
                  <b>+165</b>{" "}
                </h3>
                <p>
                  {" "}
                  derechos de autor sobre software, base de datos y obras
                  literarias
                </p>
              </>
            }
            col4={
              <>
                <h3>
                  <b>+64</b>
                </h3>
                <p>
                  secretos industriales de registros transferidos al sector
                  productivo
                </p>
              </>
            }
          ></Block4Columns>
        </center>
      </div>

      <div className="padding ">
        <center>
          <h2 className="width500">
            Confiamos en el poder de las conexiones globales para{" "}
            <b>impulsar nuestro impacto</b>
          </h2>
          <p className="layout6">
            Nos enlazamos con redes internacionales y colaboramos con parques
            científicos de prestigio para fortalecer nuestra innovación y
            emprendimiento. Estas alianzas estratégicas enriquecen nuestra
            investigación y desarrollo, ofreciendo un entorno propicio para la
            creatividad y el crecimiento.
          </p>
        </center>
        <div className="layout8">
          <center>
            {" "}
            <h3>
              Nuestras <b>redes</b>
            </h3>
          </center>
          <div className="icon100 flex-center grayicon">
            <div>
              {" "}
              <img src={red1} alt="utpl"></img>
            </div>

            <div>
              {" "}
              <img src={red2} alt="utpl"></img>
            </div>
            <div>
              {" "}
              <img src={agro} alt="utpl"></img>
            </div>
            <div>
              {" "}
              <img src={cedia} alt="utpl"></img>
            </div>
            <div>
              <img src={citec} alt="utpl"></img>
            </div>

            <div>
              <img src={babson} alt="utpl"></img>
            </div>
          </div>
        </div>

        <div className="layout8  grayicon">
          <center>
            {" "}
            <h3>
              Parques Científicos <b>aliados</b>
            </h3>
          </center>
          <div className="icon100 flex-center">
            <div>
              {" "}
              <img src={parque1} alt="utpl"></img>
            </div>
            <div>
              {" "}
              <img src={parque2} alt="utpl"></img>
            </div>
          </div>
        </div>
      </div>
      <div>
        <DataFetcherNews url="https://noticias.utpl.edu.ec/parque/servicio-parque.json" />
      </div>
      <div className="layout8 padding2">
        <h2>
          Conoce nuestro <b>equipo</b>
        </h2>
        <p>
          Contamos con un equipo diverso y talentoso, dedicado a la excelencia y
          la innovación. Cada miembro contribuye con su experiencia y
          habilidades únicas, enriqueciendo nuestro enfoque y resultados.
        </p>
        <div className="flex-center">
          <Flipcard
            src={juan_pablo_}
            content={
              <>
                <p> Juan Pablo Suárez Chacón</p>
                <p>
                  <b> Director Parque Científico y Tecnológico UTPL</b>
                </p>
              </>
            }
          ></Flipcard>

          <Flipcard
            src={mauricio_eguiguren}
            content={
              <>
                <p>Mauricio Eguiguren</p>
                <p>Coordinador de gestión y transferencia de conocimiento</p>
              </>
            }
          ></Flipcard>

          <Flipcard
            src={jaime_roman}
            content={
              <>
                <p>Jaime Román</p>
                <p>Coordinador de innovación </p>
              </>
            }
          ></Flipcard>

          <Flipcard
            src={galo_ojeda}
            content={
              <>
                <p>Galo Ojeda</p>
                <p>Gestor de innovación</p>
              </>
            }
          ></Flipcard>

          <Flipcard
            src={adriana}
            content={
              <>
                <p>Adriana Lourdes Riofrío Silva </p>
                <p>Gestor de innovación</p>
              </>
            }
          ></Flipcard>

          <Flipcard
            src={diana_sanchez}
            content={
              <>
                <p>Diana Sánchez</p>
                <p>Gestor de transferencia de conocimiento</p>
              </>
            }
          ></Flipcard>

          <Flipcard
            src={noelia}
            content={
              <>
                <p>Noelia Salomé Ochoa Salinas</p>
                <p>Asistente</p>
              </>
            }
          ></Flipcard>
        </div>{" "}
      </div>

      <div className=" padding ">
        {" "}
        <div className="layout8 ">
          <center>
            <h2 className="width500">
              {" "}
              <b>¿Interesado</b> en nuestro parque científico y
              tecnológico?{" "}
            </h2>
            <p>
              Escríbenos a <b>infopct@utpl.edu.ec</b> y solicita más
              información{" "}
            </p>

            <div className="icon50 flex-center margin">
              <motion.div
                initial={{ x: -50, opacity: 0 }}
                whileInView={{
                  x: 0,
                  opacity: 1,
                  transition: {
                    delay: 0.1,
                  },
                }}
              >
                <a href="https://www.facebook.com/InvestigaUTPL/">
                  <img src={facebook} alt="utpl"></img>
                </a>
              </motion.div>
              <motion.div
                initial={{ x: -50, opacity: 0 }}
                whileInView={{
                  x: 0,
                  opacity: 1,
                  transition: {
                    delay: 0.1,
                  },
                }}
              >
                <a href="https://www.instagram.com/utplinvestiga/">
                  {" "}
                  <img src={instragram} alt="utpl"></img>
                </a>
              </motion.div>
              <motion.div
                initial={{ x: -50, opacity: 0 }}
                whileInView={{
                  x: 0,
                  opacity: 1,
                  transition: {
                    delay: 0.1,
                  },
                }}
              >
                <a href="https://x.com/utplinvestiga/">
                  {" "}
                  <img src={x} alt="utpl"></img>
                </a>
              </motion.div>
            </div>
          </center>
        </div>
      </div>
      {/*  <FixedNotification
        link="https://eventos.utpl.edu.ec/vii-convocatoria-de-retos-de-innovacion-empresarial"
        content={
          <>
            <img src="https://www.utpl.edu.ec/carreras/sites/default/files/retos-innovacion.jpg"></img>
          </>
        }
      ></FixedNotification> */}
    </>
  );
}

export default ParqueCientifico;
